import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/license/addOns/catalog/license.addOn.catalog.query.gql"
import type {
  AddOnCatalogQuery,
  AddOnCatalogQueryVariables,
} from "@/v2-backoffice-client/license/addOns/catalog/__types__/license.addOn.catalog.query"

type Options = QueryHookOptions<AddOnCatalogQuery, AddOnCatalogQueryVariables>

export function useAddOnCatalogQuery(options?: Options) {
  return useQuery<AddOnCatalogQuery, AddOnCatalogQueryVariables>(query, options)
}
